var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEikowBis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 24,
    viewBox: "0 0 88 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.65824 6.743C10.2468 6.743 11.6978 7.13009 13.0123 7.90258C14.3267 8.67592 15.3671 9.70817 16.1335 10.9985C16.8998 12.2897 17.2942 13.7355 17.3165 15.3377V16.94H17.0484V16.9571H8.52422V13.6193H13.6755C13.2949 12.5734 12.6549 11.7223 11.7545 11.066C10.8542 10.4097 9.8215 10.0816 8.65824 10.0816C7.20375 10.0816 5.9563 10.596 4.91676 11.6257C3.87636 12.6554 3.35659 13.8987 3.35659 15.3557C3.35659 16.3683 3.62808 17.2698 4.17018 18.0594C4.71229 18.8498 5.38928 19.4693 6.20029 19.9205C7.0113 20.3709 7.84723 20.6076 8.70893 20.6298L8.62474 23.9675C6.45459 23.8898 4.50782 23.0891 2.78528 21.5646C0.928712 19.7941 0 17.7244 0 15.3548C0 13.7748 0.39176 12.3315 1.17442 11.0241C1.95708 9.71672 3.00349 8.67677 4.31194 7.90343C5.62038 7.13009 7.06887 6.74385 8.65824 6.74385V6.743Z",
    fill: "url(#paint0_linear_2781_10431)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0076 6.82589C36.0076 8.46144 35.6021 9.95001 34.7911 11.2908C33.98 12.6315 32.8975 13.686 31.5444 14.4533C32.8975 15.1993 33.9775 16.2307 34.7833 17.5492C35.5892 18.8678 35.9973 20.3444 36.0084 21.9808V24H32.6527V21.9808C32.6527 20.5452 32.1518 19.3215 31.1509 18.3089C30.1501 17.2963 28.9112 16.7622 27.4344 16.7067V24H24.0786V0H27.4344V12.1837C28.9112 12.1282 30.1501 11.589 31.1509 10.5644C32.1518 9.5407 32.6527 8.29481 32.6527 6.82589H36.0084H36.0076Z",
    fill: "url(#paint1_linear_2781_10431)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3652 6.743C47.9648 6.743 49.4193 7.13009 50.7278 7.90258C52.0362 8.67592 53.0792 9.71672 53.8576 11.0233C54.6351 12.3307 55.0234 13.7748 55.0234 15.354C55.0234 16.9331 54.6342 18.3781 53.8576 19.6847C53.0801 20.9921 52.0371 22.0329 50.7278 22.8054C49.4193 23.5787 47.9648 23.965 46.3652 23.965C44.7655 23.965 43.3282 23.5787 42.0188 22.8054C40.7104 22.032 39.664 20.9921 38.8813 19.6847C38.0978 18.3773 37.7069 16.934 37.7069 15.354C37.7069 13.774 38.0987 12.3307 38.8813 11.0233C39.664 9.71587 40.7104 8.67592 42.0188 7.90258C43.3273 7.12924 44.7766 6.743 46.3652 6.743ZM46.3652 20.6289C47.8308 20.6289 49.0808 20.1145 50.1152 19.0848C51.1496 18.056 51.6677 16.8126 51.6677 15.3548C51.6677 13.897 51.1505 12.6537 50.1152 11.6249C49.0808 10.596 47.83 10.0807 46.3652 10.0807C44.9003 10.0807 43.6632 10.5952 42.6237 11.6249C41.5833 12.6546 41.0635 13.8979 41.0635 15.3548C41.0635 16.8118 41.5833 18.056 42.6237 19.0848C43.6641 20.1145 44.9115 20.6289 46.3652 20.6289Z",
    fill: "url(#paint2_linear_2781_10431)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6443 15.3548V6.82674H88V15.3548C88 16.9348 87.6082 18.379 86.8256 19.6855C86.042 20.9929 84.9965 22.0337 83.688 22.8062C82.3796 23.5796 80.9303 23.9658 79.3418 23.9658C77.9096 23.9658 76.59 23.6488 75.382 23.0147C74.1741 22.3807 73.1672 21.5236 72.3614 20.4443C71.5555 21.5236 70.5495 22.3807 69.3407 23.0147C68.1319 23.6488 66.8123 23.9658 65.381 23.9658C63.7925 23.9658 62.344 23.5796 61.0347 22.8062C59.7262 22.0329 58.6798 20.9929 57.8972 19.6855C57.1137 18.3781 56.7228 16.9348 56.7228 15.3548V6.82674H60.0785V15.3548C60.0785 16.8126 60.5983 18.056 61.6387 19.0848C62.6791 20.1145 63.9265 20.6289 65.3801 20.6289C66.8338 20.6289 68.0288 20.1478 69.0297 19.1856C70.0306 18.2234 70.5821 17.0246 70.6826 15.589V6.82674H74.0384V15.589C74.1389 17.0246 74.693 18.2234 75.6999 19.1856C76.7068 20.1478 77.9208 20.6289 79.3409 20.6289C80.761 20.6289 82.0566 20.1145 83.091 19.0848C84.1253 18.056 84.6434 16.8126 84.6434 15.3548H84.6443Z",
    fill: "url(#paint3_linear_2781_10431)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3776 6.82585H19.0219V24H22.3776V6.82585Z",
    fill: "url(#paint4_linear_2781_10431)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.387 3.21556C21.9033 3.21556 20.6997 4.41189 20.6997 5.88849C20.6997 4.41274 19.4969 3.21556 18.0124 3.21556C19.4961 3.21556 20.6997 2.01924 20.6997 0.542627C20.6997 2.01838 21.9025 3.21556 23.387 3.21556Z",
    fill: "url(#paint5_linear_2781_10431)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0525 15.4129C47.5688 15.4129 46.3652 16.6092 46.3652 18.0858C46.3652 16.6101 45.1624 15.4129 43.6779 15.4129C45.1616 15.4129 46.3652 14.2166 46.3652 12.74C46.3652 14.2157 47.568 15.4129 49.0525 15.4129Z",
    fill: "url(#paint6_linear_2781_10431)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2781_10431",
    x1: -86.8262,
    y1: 19.875,
    x2: 304.888,
    y2: -0.214223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC736D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.142476,
    stopColor: "#DB5D58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E85576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446912,
    stopColor: "#E4489C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.580759,
    stopColor: "#BE45AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#7B44BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855,
    stopColor: "#5671EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#739BF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2781_10431",
    x1: -86.8262,
    y1: 19.875,
    x2: 304.888,
    y2: -0.214223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC736D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.142476,
    stopColor: "#DB5D58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E85576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446912,
    stopColor: "#E4489C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.580759,
    stopColor: "#BE45AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#7B44BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855,
    stopColor: "#5671EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#739BF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2781_10431",
    x1: -86.8262,
    y1: 19.875,
    x2: 304.888,
    y2: -0.214223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC736D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.142476,
    stopColor: "#DB5D58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E85576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446912,
    stopColor: "#E4489C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.580759,
    stopColor: "#BE45AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#7B44BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855,
    stopColor: "#5671EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#739BF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2781_10431",
    x1: -86.8262,
    y1: 19.875,
    x2: 304.888,
    y2: -0.214223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC736D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.142476,
    stopColor: "#DB5D58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E85576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446912,
    stopColor: "#E4489C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.580759,
    stopColor: "#BE45AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#7B44BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855,
    stopColor: "#5671EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#739BF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2781_10431",
    x1: -86.8262,
    y1: 19.875,
    x2: 304.888,
    y2: -0.214223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC736D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.142476,
    stopColor: "#DB5D58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E85576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446912,
    stopColor: "#E4489C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.580759,
    stopColor: "#BE45AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#7B44BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855,
    stopColor: "#5671EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#739BF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2781_10431",
    x1: -86.8262,
    y1: 19.875,
    x2: 304.888,
    y2: -0.214223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC736D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.142476,
    stopColor: "#DB5D58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E85576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446912,
    stopColor: "#E4489C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.580759,
    stopColor: "#BE45AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#7B44BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855,
    stopColor: "#5671EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#739BF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2781_10431",
    x1: -86.8262,
    y1: 19.875,
    x2: 304.888,
    y2: -0.214223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC736D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.142476,
    stopColor: "#DB5D58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E85576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446912,
    stopColor: "#E4489C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.580759,
    stopColor: "#BE45AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#7B44BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855,
    stopColor: "#5671EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#739BF5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEikowBis);
export default __webpack_public_path__ + "static/media/eikow-bis.861602d63801d2ac5144f068b78e3c33.svg";
export { ForwardRef as ReactComponent };